<template>
  <a-modal
    title="提示"
    :mask-closable="false"
    v-model="visible"
    @cancel="cancel"
  >
    <p>您有改动尚未保存, 关闭即将失去这些改动. 请问您是否保存?</p>
    <template slot="footer">
      <a-button @click="save" :loading="saving" type="primary">保存</a-button>
      <a-button @click="discard">不保存</a-button>
      <a-button @click="cancel">取消</a-button>
    </template>
  </a-modal>
</template>

<script>
export default {
  components: {

  },
  data () {
    return {
      visible: false,
      option: {},
      saving: false
    }
  },
  methods: {
    confirm (option) {
      this.visible = true
      this.option = option
    },
    save () {
      console.log(typeof this.option.onSave)
      if (this.option.onSave instanceof Function) {
        this.saving = true
        this.option.onSave()
      }
    },
    discard () {
      if (this.option.onDiscard instanceof Function) {
        this.option.onDiscard()
      }
    },
    cancel () {
      this.visible = false
    }
  }
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/design/CloseConfirm.vue